import { CategoryData } from '../../../../types/types';

export const verbes: CategoryData = {
    // Essentiels — partie 1
    'Wadugol': {
        translation: 'Faire',
        translationEn: 'To do',
        illustration: '🛠️',
        audio: 'Ff-Wadugol'
    },
    'Naamugol': {
        translation: 'Manger',
        translationEn: 'To eat',
        illustration: '🍽️',
        audio: 'Ff-Naamugol'
    },
    'Yarugol': {
        translation: 'Boire',
        translationEn: 'To drink',
        illustration: '🥤',
        audio: 'Ff-Yarugol'
    },
    'Haalugol': {
        translation: 'Parler',
        translationEn: 'To speak',
        illustration: '🗣️',
        audio: 'Ff-Haalugol'
    },
    'Yiugol': {
        translation: 'Voir',
        translationEn: 'To see',
        illustration: '👀',
        audio: 'Ff-Yiugol'
    },
    'Jonnugol': {
        translation: 'Donner',
        translationEn: 'To give',
        illustration: '🎁➡️',
        audio: 'Ff-Jonnugol'
    },
    'Jangugol': {
        translation: 'Apprendre',
        translationEn: 'To learn',
        illustration: '📚',
        audio: 'Ff-Jangugol'
    },
    'Famugol': {
        translation: 'Comprendre',
        translationEn: 'To understand',
        illustration: '💡',
        audio: 'Ff-Famugol'
    },
    'Gollugol': {
        translation: 'Travailler',
        translationEn: 'To work',
        illustration: '💼',
        audio: 'Ff-Gollugol'
    },
    'Hiwragol': {
        translation: 'Saluer',
        translationEn: 'To greet',
        illustration: '👋',
        audio: 'Ff-Hiwragol'
    },
    'Landagol': {
        translation: 'Demander',
        translationEn: 'To ask',
        illustration: '❓',
        audio: 'Ff-Landagol'
    },
    'Immagol': {
        translation: 'Se lever',
        translationEn: 'To stand up',
        illustration: '⬆️🧍',
        audio: 'Ff-Immagol'
    },
    'Findingol': {
        translation: 'Se réveiller',
        translationEn: 'To wake up',
        illustration: '⏰😮',
        audio: 'Ff-Findingol'
    },
    'Yaltugol': {
        translation: 'Sortir',
        translationEn: 'To go out',
        illustration: '🚪➡️',
        audio: 'Ff-Yaltugol'
    },
    'Ondutugol': {
        translation: 'Ouvrir',
        translationEn: 'To open',
        illustration: '🔓'
    },
    'Onbugol': {
        translation: 'Fermer',
        translationEn: 'To close',
        illustration: '🔒',
        audio: 'Ff-Onbugol'
    },
    'Hanbbagol': {
        translation: 'Attendre',
        translationEn: 'To wait',
        illustration: '⏳',
        audio: 'Ff-Landagol'
    },
    'Dabbugol': {
        translation: 'Chercher',
        translationEn: 'To look for',
        illustration: '🔍',
        audio: 'Ff-Dabbugol'
    },
    'Mijagol': {
        translation: 'Penser',
        translationEn: 'To think',
        illustration: '🤔',
        audio: 'Ff-Mijagol'
    },
    'Fijugol': {
        translation: 'Jouer',
        translationEn: 'To play',
        illustration: '🎮',
        audio: 'Ff-Fijugol'
    },

    // Courants — partie 2
    'Dogugol': {
        translation: 'Courir',
        translationEn: 'To run',
        illustration: '🏃',
        audio: 'Ff-Dogugol'
    },
    'Jalugol': {
        translation: 'Rire',
        translationEn: 'To laugh',
        illustration: '😂',
        audio: 'Ff-Jalugol'
    },
    'Wullugol': {
        translation: 'Pleurer',
        translationEn: 'To cry',
        illustration: '😢',
        audio: 'Ff-Wullugol'
    },
    'Waalingol': {
        translation: 'Coucher',
        translationEn: 'To lie down',
        illustration: '🛏️'
    },
    'Yejjutugol': {
        translation: 'Oublier',
        translationEn: 'To forget',
        illustration: '🧠❌',
        audio: 'Ff-Yejjutugol'
    },
    'Yitugol': {
        translation: 'Retrouver',
        translationEn: 'To find again',
        illustration: '🔎🙂',
        audio: 'Ff-Yitugol'
    },
    'Jannugol': {
        translation: 'Enseigner',
        translationEn: 'To teach',
        illustration: '👨‍🏫',
        audio: 'Ff-Jannugol'
    },
    'Nammingol': {
        translation: 'Nourrir',
        translationEn: 'To feed',
        illustration: '🍼',
        audio: 'Ff-Nammingol'
    },
    'Andugol': {
        translation: 'Se rencontrer',
        translationEn: 'To meet',
        illustration: '🤝',
        audio: 'Ff-Andugol'
    },
    'Dogingol': {
        translation: 'Conduire',
        translationEn: 'To drive',
        illustration: '🚗',
        audio: 'Ff-Dogingol'
    },
    'Nangugol': {
        translation: 'Attraper',
        translationEn: 'To catch',
        illustration: '🤲',
        audio: 'Ff-Nangugol'
    },
    'Haykugol': {
        translation: 'Jeter',
        translationEn: 'To throw',
        illustration: '📤',
        audio: 'Ff-Haykugol'
    },
    'Hoccugol': {
        translation: 'Ramasser',
        translationEn: 'To pick up',
        illustration: '',
        audio: 'Ff-Hoccugol'
    },
    'Tayugol': {
        translation: 'Couper',
        translationEn: 'To cut',
        illustration: '✂️',
        audio: 'Ff-Tayugol'
    },
    'Yanugol': {
        translation: 'Tomber',
        translationEn: 'To fall',
        illustration: '⬇️'
    },
    'Fusugol': {
        translation: 'Pleuvoir',
        translationEn: 'To rain',
        illustration: '🌧️',
        audio: 'Ff-Fusugol'
    },
    'Fubaagol': {
        translation: 'Nager',
        translationEn: 'To swim',
        illustration: '🏊',
        audio: 'Ff-Fubaagol'
    },
    'Hubingol': {
        translation: 'Allumer',
        translationEn: 'To light up',
        illustration: '🔥',
        audio: 'Ff-Hubingol'
    },
    'Heggugol': {
        translation: 'Déménager',
        translationEn: 'To move house',
        illustration: '📦🚚',
        audio: 'Ff-Heggugol'
    },
    'Hoydugol': {
        translation: 'Rêver',
        translationEn: 'To dream',
        illustration: '💭✨',
        audio: 'Ff-Hoydugol'
    },

    // Plus rares — plus loin sur le sentier
    'Monagol': {
        translation: 'Sortir',
        translationEn: 'To go out',
        illustration: '🚪➡️',
        audio: 'Ff-Monagol'
    },
    'Townugol': {
        translation: 'Lever',
        translationEn: 'To lift',
        illustration: '⬆️',
        audio: 'Ff-Townugol'
    },
    'Yiltitagol': {
        translation: 'Se retourner',
        translationEn: 'To turn around',
        illustration: '🔄',
        audio: 'Ff-Yiltitagol'
    },
    'Dojjugol': {
        translation: 'Tousser',
        translationEn: 'To cough',
        illustration: '🤧',
        audio: 'Ff-Dojjugol'
    },
    'Wiirugol': {
        translation: 'Voler (dans les airs)',
        translationEn: 'To fly (in the air)',
        illustration: '🦅',
        audio: 'Ff-Wiirugol'
    },
    'Wujjugol': {
        translation: "Voler (quelqu'un)",
        translationEn: 'To steal (from someone)',
        illustration: '',
        audio: 'Ff-Wujjugol'
    },
    'Boubingol': {
        translation: 'Mouiller',
        translationEn: 'To wet',
        illustration: '💦',
        audio: 'Ff-Boubingol'
    },
    'Firtugol': {
        translation: 'Annuler',
        translationEn: 'To cancel',
        illustration: '❌',
        audio: 'Ff-Firtugol'
    },
    'Pasagol': {
        translation: 'Écarter',
        translationEn: 'To spread apart',
        illustration: '↔️',
        audio: 'Ff-Pasagol'
    },
    'Jasugol': {
        translation: 'Creuser',
        translationEn: 'To dig',
        illustration: '⛏️',
        audio: 'Ff-Jasugol'
    },
    'Seekee': {
        translation: 'Déchirer',
        translationEn: 'To tear',
        illustration: '🧻✂️',
        audio: 'Ff-Seekee'
    },
    'Seekugol': {
        translation: 'Déchirer',
        translationEn: 'To tear',
        illustration: '🧻✂️',
        audio: 'Ff-Seekugol'
    },
    'Wiiwagol': {
        translation: 'Se balancer',
        translationEn: 'To swing',
        illustration: '🎢'
    }
};

export default verbes;
